import { Component, Input } from '@angular/core';
import { ToolsProvider } from '../../../providers/tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';
import { CrudApiProvider } from '../../../providers/crud-api/crud-api';
import { NewsBrowserProvider } from '../../../providers/news-browser/news-browser';

declare let CmKit: any;

@Component({
  selector: 'lc-links',
  templateUrl: 'links.html',
})
export class LCLinksComponent {
  log = debug('app:LCLinksComponent');

  @Input() linkUrl: string = '';
  @Input() lcStyle: boolean = true;

  loading: boolean = true;
  title: string = '';
  description: string = '';
  image: string = '';
  domain: string = '';
  failedToLoad = false;

  constructor(
    public crudApi: CrudApiProvider,
    public tools: ToolsProvider,
    public newsBrowser: NewsBrowserProvider
  ) {}

  ngOnInit(): void {
    if (this.linkUrl !== undefined) {
      this.getLinkData(this.linkUrl);
    }
  }

  async getLinkData(linkUrl: string | undefined): Promise<void> {
    if (!linkUrl) {
      console.warn('Invalid link URL provided.');
      return;
    }

    try {
      const response = await this.crudApi.post('/api/metadata', {
        url: linkUrl,
      });

      this.title = response?.data?.title;
      this.description = response?.data?.description;
      this.image = response?.data?.image;
      this.domain = this.extractDomain(linkUrl);
      this.loading = false;
    } catch (error) {
      console.error('Failed to fetch link data:', error);

      this.loading = true;
      this.failedToLoad = true;
    }
  }

  extractDomain(url: string): string {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.hostname.replace(/^www\./, '');
    } catch (error) {
      console.error('Invalid URL:', url);
      return '';
    }
  }

  async navToLink() {
    const regex = /^https?:\/\/(www\.)?cdllife\.com\/20.*?$/;

    if (regex.test(this.linkUrl)) {
      const mobileArticle = await this.tools.getNewsArticleFromUrl(
        this.linkUrl
      );

      if (mobileArticle) {
        this.log('openLink | cdllife article', mobileArticle);
        return this.newsBrowser.openArticle(mobileArticle);
      } else {
        this.log('openLink | external link', this.linkUrl);
        this.tools.openExternalUrl(this.linkUrl, '_blank', {});
      }
    } else {
      this.log('openLink | outside url', this.linkUrl);
      this.tools.openExternalUrl(this.linkUrl, '_blank', {});
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/links/links.ts